// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"1024px"};